import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { button, buttonProgress, ButtonProps } from '@kite_aerolab/shared/components';
import { dark as darkMode } from '@kite_aerolab/shared/themes/supervielle/dark';

@Component({
  selector: 'kite-button',
  template: `
    <button
      [disabled]="isDisabled || !!isLoading || !!isProcess"
      [ngClass]="button"
      (click)="onClick.emit($event)"
      role="button"
      [type]="type || 'button'"
      [attr.aria-label]= "isLoading ? 'loading' : null"
    >
      <span class="button-text" [ngClass]="isLoading ? 'is-hidden' : ''" [attr.aria-hidden]="isLoading ? true : null" #ref>
        <ng-content></ng-content>
      </span>
      <span
        [ngClass]="buttonProgress"
        *ngIf="isProcess && processProgress && (!variant || variant === 'primary')"
        [ngStyle]="{ width: processProgress + '%' }"
      ></span>
      
      <kite-icon [attr.aria-hidden]="isLoading ? true : null" *ngIf="!!icon" [ngClass]="isLoading ? 'is-hidden' : ''" [name]="icon" [size]="ref && ref.childNodes.length ? 'sm' : 'md'"></kite-icon>
      <div [ngClass]="(isDark && variant === 'tertiary') || (!isDark && (!variant || variant === 'primary')) ? darkMode : ''" class="spinner-container" *ngIf="isLoading">
        <kite-spinner size="xs"></kite-spinner>
      </div>
      </button>
  `,
})
export class ButtonComponent {
  /**
   * Css class
   */
  @Input() css: ButtonProps['css'];
  /**
   * Classname del botón
   */
  @Input() className: ButtonProps['className'];
  /**
   * Disabled
   */
  @Input() isDisabled: ButtonProps['isDisabled'];
  /**
   * ID del componente
   */
  @Input() id: ButtonProps['id'];
  /**
   * Estado de isLoading: true o false.
   */
  @Input() isLoading: ButtonProps['isLoading'];
    /**
   * Estado del proceso: true or false
   */
     @Input() isProcess: ButtonProps['isProcess'];
  /**
   * Progreso del botón en proceso en porcentaje
   */
  @Input() processProgress: ButtonProps['processProgress'];
  /**
   * Icono del botón
   */
  @Input() icon: ButtonProps['icon'];

  /**
   * Tamaño del botón: sm o md
   */
  @Input() size: ButtonProps['size'];
  /**
   * Tipo de botón
   */
  @Input() type: ButtonProps['type'];
  /**
   * Variante del botón
   */
  @Input() variant: ButtonProps['variant'];
  /**
   * Block true hace que el tamaño sea del 100%
   */
  @Input() isBlock: ButtonProps['isBlock'];

  /**
   * tema del botón (light o dark)
   */
  @Input() isDark: ButtonProps['isDark'];
  /**
   * Optional click handler
   */
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  @ViewChild('ref') ref: ElementRef<HTMLSpanElement>;

  public get button(): string[] {
    return [
      button({
        css: this.css,
        variant: this.variant,
        size: this.size,
        isDisabled: this.isDisabled || !!this.isLoading || !!this.isProcess,
        isBlock: this.isBlock,
        isProcess: this.isProcess,
        onlyIcon: !!(this.icon && this.ref && !this.ref.nativeElement.childNodes.length),
        isDark: this.isDark,
        isLoading: this.isLoading,
      }).className,
    ];
  }
  
  public get darkMode(): string {
    return darkMode.className
  }

  public get buttonProgress(): string[] {
    return [
      buttonProgress({
        isDark: this.isDark,
      }).className,
    ];
  }
}
